var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"size":_vm.size,"value":_vm.name,"readonly":"readonly","suffix-icon":"fa fa-sitemap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }